export default {
  className: 'notice',
  fields: [
    {
      name: 'heading',
      validators: [
        (val) => val ? null : '不可为空'
      ]
    },
    {
      name: 'banner',
      validators: [
        (val) => val ? null : '不可为空'
      ]
    },
    {
      name: 'details',
      validators: [
        (val) => val ? null : '不可为空'
      ]
    }
    // {
    //   name: 'residentialQuarters',
    //   render: (record) => {
    //     return `${record.residentialQuarters.name}`
    //   },
    //   validators: [
    //     (val) => val ? null : '关联小区不可为空'
    //   ]
    // }
  ],
  search: [
    'heading'
    // 'residentialQuarters'
  ]
}
